<script>
    import { onMount } from "svelte";
    import { bgColor } from "./stores/background_color";

    export let size = 100; // Default size if not provided

    let canvas;
    let ctx;
    let animationFrameId;

    onMount(() => {
        ctx = canvas.getContext("2d");
        animate();

        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    });

    function animate() {
        const width = size;
        const height = size;
        const radius = size / 4; // Adjust radius based on size
        const lineWidth = size / 12.5; // Adjust line width based on size
        const speed = 0.05;
        let angle = 0;

        canvas.width = width;
        canvas.height = height;

        let lastTime = performance.now();
        let dt;

        let length = 0;
        let inc = true;

        function drawLoader() {
            const now = performance.now();
            dt = now - lastTime;
            lastTime = now;

            dt /= 1000;

            length += inc ? 0.05 : -0.05;

            if (length > 6 && inc) {
                inc = false;
                length = 6;
            } else if (length < 0 && !inc) {
                length = 0;
                inc = true;
            }

            // console.log(length);

            ctx.clearRect(0, 0, width, height);
            ctx.save();
            ctx.translate(width / 2, height / 2);
            ctx.rotate(now / 100 - length);
            ctx.strokeStyle = $bgColor;
            ctx.lineWidth = lineWidth;

            ctx.beginPath();
            ctx.arc(0, 0, radius, 0, length);
            ctx.lineCap = "round";
            ctx.stroke();
            ctx.restore();
            angle += speed;
            animationFrameId = requestAnimationFrame(drawLoader);
        }

        drawLoader();
    }
</script>

<canvas bind:this={canvas} style="background: transparent;"></canvas>

<style>
    canvas {
        display: block;
        margin: auto;
    }
</style>
